import { MIME_TYPE_MERGE_PATCH_JSON } from "@rumble-it/common-lib/src/constants/mimeTypes";
import { axiosInstance } from "../client";
import { SmsSent } from "@rumble-it/common-lib/types/models/SmsSent.interface";
import { SmsTemplate } from "@rumble-it/common-lib/types/models/SmsTemplate.interface";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";

export const fetchSmsTemplates = async (): Promise<
  CollectionResponse<SmsTemplate>
> =>
  axiosInstance.get(`/admin/sms-templates`).then((response) => response.data);

export const createSmsTemplate = async (
  data: SmsTemplate,
): Promise<SmsTemplate> =>
  axiosInstance
    .post(`/admin/sms-templates`, data)
    .then((response) => response.data);

export const updateSmsTemplateById = async (
  id: string,
  data: SmsTemplate,
): Promise<null> =>
  axiosInstance
    .patch(`/admin/sms-templates/${id}`, data, {
      headers: { "Content-Type": MIME_TYPE_MERGE_PATCH_JSON },
    })
    .then((response) => response.data);

export const deleteSmsTemplateById = async (id: string): Promise<null> =>
  axiosInstance
    .delete(`/admin/sms-templates/${id}`)
    .then((response) => response.data);

export const fetchSmsTemplateById = async (id: string): Promise<SmsTemplate> =>
  axiosInstance
    .get(`/admin/sms-templates/${id}`)
    .then((response) => response.data);

export const fetchSmsSentDetailsById = async (id: string): Promise<SmsSent> =>
  axiosInstance.get(`/admin/sms/sent/${id}`).then((response) => response.data);
